import PropTypes from 'prop-types';
import cx from 'classnames';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import Link from 'core/components/Link';
import Lightning from 'core/components/GameCompare/Lightning';


// Стили вынесены в style jsx для amp страниц
function GameCompare(props) {
  const {
    block,
    parentProps: {
      theme: {
        controls: {
          smartTeaser: {
            gameCompare: gameCompareAtoms,
          },
        },
      },
      isMobile,
    },
  } = props;

  const {
    attributes: {
      teaser_params: {
        headline,
        listHeadline,
        variants,
        left_winner: leftWinner,
        right_winner: rightWinner,
      },
      url,
      teaser_type: teaserType,
    },
  } = block;

  if (variants?.length === 0 && !leftWinner && !rightWinner) return null;

  const pair = teaserType ===  'pair_compare' ? [leftWinner, rightWinner] : variants?.slice(0, 2);

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          text-decoration none
      `}</style>
    </scope>
  );

  return (
    <div className={cx(
      'wrapper',
      gameCompareAtoms.border.showBorder && '_border',
      gameCompareAtoms.headline.center && '_center')}
    >
      <style jsx>{`
        .wrapper
          background ${gameCompareAtoms.background}
          padding ${gameCompareAtoms.padding}
          display flex
          flex-direction column
          border-radius 4px
          overflow hidden
          box-sizing border-box
          &._border
            :global(.mobile) &
              border-radius 0
          :global(img)
            border-radius 0
          &._border
            border ${gameCompareAtoms.border.borderValue}
          :global(.mobile) &
            border-right none
            border-left none

        .variants
          display block
          border-radius 8px
          overflow hidden
          width 100%
          margin 0 auto
          max-width 580px
          text-decoration none
          box-shadow 0px 1px 2px rgba(0, 0, 0, 0.11)
          :global(.mobile) &
            max-width 550px

        .headline
          font ${gameCompareAtoms.headline.font}
          color ${gameCompareAtoms.headline.color}
          background ${gameCompareAtoms.headline.background}
          padding 20px 25px 20px
          :global(.mobile) &
            padding 10px 15px 10px
          .variants:hover &
            text-decoration underline
          ._center &
            text-align center

        .readMore
          font ${gameCompareAtoms.readMore.font}
          color ${gameCompareAtoms.readMore.color}
          text-align center
          margin-bottom 15px
          :global(.mobile) &
            text-align left
      `}</style>
      <div className='readMore'>{gameCompareAtoms.readMore.text}</div>
      <Link
        to={url}
        type='blank'
        className={scoped.wrapClassNames('link')}
      >
        <div className='variants'>
          <Lightning
            imageMaxWidth={gameCompareAtoms.imageMaxWidth}
            pair={pair}
            progressType={gameCompareAtoms.progressType}
            height={isMobile ? 265 : 390}
            borderRadius={gameCompareAtoms.borderRadius}
            lightningColor={gameCompareAtoms.lightningColor}
          />
          <div className='headline'>
            {listHeadline || headline}
          </div>
        </div>
      </Link>
      <scoped.styles />
    </div>
  );
}

GameCompare.propTypes = {
  block: PropTypes.object,
  parentProps: PropTypes.object,
};


export default GameCompare;
